import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import store from '../src/Store/Store'
import { RecoilRoot } from 'recoil';
import { ReactDOM } from 'react'
import "./index.css"
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { NextUIProvider } from '@nextui-org/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { Toaster } from 'sonner'

const queryclient = new QueryClient()
createRoot(document.getElementById('root')).render(
  <QueryClientProvider client={queryclient}>
    <NextUIProvider locale='en-GB'>
      <RecoilRoot>
        <Provider store={store}>
          <App />
          <Toaster richColors  position="bottom-center" closeButton/>
        </Provider>
        
      </RecoilRoot>
    </NextUIProvider>
  </QueryClientProvider>,
)

// ReactDOM.render(<RecoilRoot><Provider store={store}><App /> </Provider> </RecoilRoot>, document.getElementById('root'));


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
defineCustomElements(window);
